import { cx } from 'utils/cx'

import type { ActiveOrderType } from '../../../types/activePurchases.types'
import { StatusLines } from '../../../types/purchases.types'
import { LineImage } from './LineImage/LineImage'

import styles from './OrderImages.module.scss'

export const OrderImages = ({ lastOrder }: { lastOrder: ActiveOrderType }) => {
	return lastOrder.lines.map((line) => (
		<div
			className={cx(
				styles.imageContainer,
				line.status === StatusLines.outOfStock && styles.imageOutStock
			)}
			key={`${line.id}-${line.colorId}`}
		>
			<LineImage line={line} />
		</div>
	))
}
